import { render, staticRenderFns } from "./ShortcutsAndVoiceCommandsTable.vue?vue&type=template&id=b2510adc&"
import script from "./ShortcutsAndVoiceCommandsTable.vue?vue&type=script&lang=js&"
export * from "./ShortcutsAndVoiceCommandsTable.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutsAndVoiceCommandsTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports